/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkRemoveTeammembershipDto } from '../models/work-remove-teammembership-dto';
import { WorkTeammembershipDto } from '../models/work-teammembership-dto';

@Injectable({ providedIn: 'root' })
export class WorkTeammembershipsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `teammembershipsV2ControllerFindByUserId()` */
  static readonly TeammembershipsV2ControllerFindByUserIdPath = '/v2/teammemberships/byUserId/{userId}';

  /**
   * Required permissions: teammemberships:read, teammemberships:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teammembershipsV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  teammembershipsV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTeammembershipDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeammembershipsV2Service.TeammembershipsV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTeammembershipDto>>;
      })
    );
  }

  /**
   * Required permissions: teammemberships:read, teammemberships:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teammembershipsV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teammembershipsV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTeammembershipDto>> {
    return this.teammembershipsV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTeammembershipDto>>): Array<WorkTeammembershipDto> => r.body)
    );
  }

  /** Path part for operation `teammembershipsV2ControllerRemoveByUserId()` */
  static readonly TeammembershipsV2ControllerRemoveByUserIdPath = '/v2/teammemberships/byUserId/{userId}';

  /**
   * Required permissions: teammemberships:delete, teammemberships:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teammembershipsV2ControllerRemoveByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teammembershipsV2ControllerRemoveByUserId$Response(
    params: {
      userId: number;
      body: WorkRemoveTeammembershipDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTeammembershipDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeammembershipsV2Service.TeammembershipsV2ControllerRemoveByUserIdPath, 'delete');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTeammembershipDto>>;
      })
    );
  }

  /**
   * Required permissions: teammemberships:delete, teammemberships:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teammembershipsV2ControllerRemoveByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teammembershipsV2ControllerRemoveByUserId(
    params: {
      userId: number;
      body: WorkRemoveTeammembershipDto
    },
    context?: HttpContext
  ): Observable<Array<WorkTeammembershipDto>> {
    return this.teammembershipsV2ControllerRemoveByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTeammembershipDto>>): Array<WorkTeammembershipDto> => r.body)
    );
  }

}
